import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { AuxiliarChofer } from "./componentes/auxiliarchofer";
import { GuiaList } from "app/features/general/operativa/items/resumenchoferze/list/componentes/guias/list";

type Entity = models.ParametroResumenChofer;
const resource = resources.ResumenChoferZE;

interface props {
    session: models.Session;
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
}

class ResumenChoferZEListNoRX extends React.PureComponent<props> {
    permisos = (x: props) => x.session.Permisos;
    value = (x: props) => x.value;

    idChofer = (x: props) => x.value.IdChoferZE;
    chofer = createSelectorRx(this.idChofer, idChofer => idChofer ? observeResource(resources.ChoferZE.getMemo, idChofer) : undefined);

    Guias = (id: number) => observeResource(resources.UsuarioZE.GetGuiasEnVehiculo ,id);

    getField = formfields(() => this.props);

    onRegresar = () => history.go('../');

    onGenerar = async () => {
        await kea.message("TODO:");
    }

    render() {
        const getField = this.getField;
        const permisos = this.permisos(this.props);
        const value = this.value(this.props);
        const UsuarioZE = getField(selectores.UsuarioZEByUserRol);
        let EsChofer = false;
        let EsProveedor = false;
        
        if (this.props.session.IdUsuarioZE != null ) {
            if (this.props.session.IdChoferZE == null) {
                value.IdUserZE = this.props.session.IdUsuarioZE
                EsProveedor = true;
            }
            else
            {
                value.IdUserZE = this.props.session.IdUsuarioZE;
                value.IdChoferZE = this.props.session.IdChoferZE; 
                EsChofer = true;
            }
        }

        const validarProveedorId = value.IdUserZE === undefined || value.IdUserZE == null? 0 : value.IdUserZE
        const ChoferZE = getField(selectores.ChoferZEByUserZE( validarProveedorId ));

        const ListGuias = this.Guias( validarProveedorId )
        const chofer = this.chofer(this.props);

        const mostrarGuiasProveedores = this.props.value.IdUserZE != null && this.props.value.IdChoferZE == null
        const mostrarGuiasChoferes = this.props.value.IdChoferZE != null
        
        return (
            <div>
                <kea.Title titulo="Resumen chofer zona extendida" onRegresar={this.onRegresar} />
                <UsuarioZE field="IdUserZE" readonly={ EsProveedor || EsChofer } label=" Seleccionar Proveedor"/>
                <ChoferZE field="IdChoferZE" readonly={ EsChofer } label="Seleccionar Chofer:" />,
                { mostrarGuiasChoferes && <AuxiliarChofer value={chofer} /> },
                { mostrarGuiasProveedores && <GuiaList value={ListGuias} /> }
            </div>
        )
    }
}

const ResumenChoferZEListRX = componentToRx(ResumenChoferZEListNoRX);

interface state {
    value?: Entity;
}

export class ResumenChoferZEList extends React.PureComponent<{}, state> {
    constructor(props) {
        super(props);
        this.state = {};
    }

    nuevoValue = (state: state) => ({} as Entity)
    valueFromState = (state: state) => state.value;
    value = createSelectorRx(this.valueFromState, this.nuevoValue, (state, nuevo) => state || nuevo);
    onChange = (value: Entity) => new Promise<void>(resolve => this.setState({ value: value }, resolve));

    render() {
        const value = this.value(this.state);
        return (
            <ResumenChoferZEListRX
                session={resources.User.SessionRx}
                value={value}
                onChange={this.onChange}
            />
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/resumenchoferze/list/list.tsx